import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractConcept } from '../../../models/Entities/Contracts/ContractConcept';
import { ContractConceptConcept } from '../../../models/Entities/Contracts/ContractConceptConcept';
import * as Functions from '../../../functions/common';

export default function ContractConceptConceptsReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    case 'CONTRACTCONCEPTCONCEPT_ADD_RECEIVE_ACTION': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptConcept?.contractConceptId);
          if (CurrentConcept) {
            /* Keep every other association and replace the one being added. */
            CurrentConcept.concepts = (CurrentConcept.concepts || [])
              .filter((concept: ContractConceptConcept) => concept.relatedContractConceptId !== a.contractConceptConcept.relatedContractConceptId)
              .concat([a.contractConceptConcept]);
            CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
            CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
          }
        }
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACTCONCEPTCONCEPT_UPDATE_RECEIVE_ACTION': {
      const auxContractUpdate = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (auxContractUpdate) {
        const currentContactConceptUpdate = auxContractUpdate.concepts?.find((concepts: ContractConcept) => concepts.id === a.contractConceptConcept.contractConceptId);
        if (currentContactConceptUpdate) {
          currentContactConceptUpdate.concepts = [...(currentContactConceptUpdate.concepts || []), a.contractConceptConcept];
          auxContractUpdate.concepts = [...(auxContractUpdate.concepts || []).filter((item: ContractConcept) => item.id !== currentContactConceptUpdate.id), currentContactConceptUpdate];
        }
      }
      return { ...currentState, list: auxContractUpdate ? [...(currentState.list || []).filter((i: Contract) => i.id !== auxContractUpdate.id), auxContractUpdate] : currentState.list };
    }
    case 'CONTRACTCONCEPTCONCEPT_GET_ALL_BY_CONTRACTCONCEPTID_RECEIVE_ACTION': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
          if (CurrentConcept) {
            CurrentConcept.concepts = a.contractConceptConcepts as ContractConceptConcept[];
            CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
            CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
          }
        }
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACTCONCEPTCONCEPT_UPDATE_ALL_BY_CONTRACTCONCEPTID_RECEIVE_ACTION': {
      const auxContractUpdateAll = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (auxContractUpdateAll) {
        const currentContactConceptUpdateAll = auxContractUpdateAll.concepts?.find((concepts: ContractConcept) => concepts.id === a.contractConceptId);
        if (currentContactConceptUpdateAll) {
          currentContactConceptUpdateAll.concepts = a.contractConceptConcepts as ContractConceptConcept[];
          auxContractUpdateAll.concepts = [...(auxContractUpdateAll.concepts || []).filter((item: ContractConcept) => item.id !== currentContactConceptUpdateAll.id), currentContactConceptUpdateAll].sort(Functions.DynamicSort('contractNumber'));
        }
      }
      return { ...currentState, list: (auxContractUpdateAll ? [...(currentState.list || []).filter((i: Contract) => i.id !== auxContractUpdateAll.id), auxContractUpdateAll] : currentState.list).sort(Functions.DynamicSort('contractNumber')) };
    }
    case 'CONTRACTCONCEPTCONCEPT_DELETE_RECEIVE_ACTION': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
          if (CurrentConcept) {
            CurrentConcept.concepts = (CurrentConcept.concepts || []).filter((item: ContractConceptConcept) => item.relatedContractConceptId !== a.relatedContractConceptId);
            CurrentAddendum.concepts = [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== CurrentConcept.id), CurrentConcept];
            CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
          }
        }
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    default:
      return currentState;
  }
}
